<template>
  <div class="headers">
    <header ref="bannerImg">
      <el-row>
        <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
          <el-row>
            <el-col :span="4" style="min-width:170px;">
              <div class="grid-content bg-purple logo" @click="hreftwo">
                <img src="../assets/blacklogo@2x.png" alt ref="image" />
                <span>
                  <b>经理云</b>
                </span>
              </div>
            </el-col>
            <el-col :span="13" class="nav_right" style="min-width:635px;">
              <div class="topsbox" style="float: right;">
                <div class="tops">
                  <router-link to="/">首页</router-link>
                </div>
                <div class="tops">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <a href="#" style="font-size:16px">产品</a>
                    </span>
                    <el-dropdown-menu slot="dropdown" style="width:100%;">
                      <el-row class="pulldown">
                        <div
                          style="margin:0 auto;overflow: hidden;display: flex;justify-content:center"
                        >
                          <el-col :span="10" style="min-width:888px">
                            <div
                              class="grid-content bg-purple-dark pulldown_b"
                              style="margin-right: 100px;margin-left:50px;"
                            >
                              <p>经理云产品</p>
                              <p>
                                <router-link to="/retail">
                                  <img src="../assets/57.png" alt /> 零售版
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/warehouse">
                                  <img src="../assets/仓库@2x(1).png" alt /> 仓库版
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/wholesaler">
                                  <img src="../assets/批发商@21x.png" alt /> 批发商版
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/process">
                                  <img src="../assets/加工中心@2x1.png" alt />加工中心版
                                </router-link>
                              </p>
                            </div>
                            <div
                              class="grid-content bg-purple-dark pulldown_b"
                              style="margin-right: 91px;"
                            >
                              <p>&nbsp;</p>
                              <p>
                                <router-link to="/businessProduct">
                                  <img src="../assets/商家后台@2x.png" alt /> 商家后台
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/publicNumberProduct">
                                  <img src="../assets/公众号@2x.png" alt /> 微信公众
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/smallProgramProduct">
                                  <img src="../assets/小程序(1)@2x.png" alt /> 微信小程序
                                </router-link>
                              </p>
                            </div>
                            <div class="pulldown_b" style="margin-right: 109px;">
                              <span
                                style="display:block;width: 1px;height:290px;background: rgba(210, 210, 210, 1);border-radius: 1px;"
                              ></span>
                            </div>
                            <div
                              class="grid-content bg-purple-dark pulldown_b"
                              style="margin-right: 135px;"
                            >
                              <p>硬件产品</p>
                              <p>
                                <router-link to="/money">
                                  <img src="../assets/收银机@2x.png" alt /> 收银机
                                </router-link>
                              </p>
                              <p>
                                <router-link to="/dispose">
                                  <img src="../assets/配置(1)@2x.png" alt /> 硬软件配置
                                </router-link>
                              </p>
                            </div>
                            <div class="grid-content bg-purple-dark pulldown_b">
                              <p>&nbsp;</p>
                            </div>
                          </el-col>
                        </div>
                      </el-row>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="tops">
                  <el-dropdown placement="bottom">
                    <span class="el-dropdown-link">
                      <a href="#" style="font-size:16px">使用教程</a>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-row class="pulldown">
                        <el-col>
                          <div class="pulldown_b" style="padding:0 40px ">
                            <p style="margin-left:10px;">视频与文档</p>
                            <p>
                              <router-link to="/course/shop">
                                <img src="../assets/1视频@2x.png" width="28px" alt /> 特色功能使用视频
                              </router-link>
                            </p>
                            <p style="margin-top:20px;">
                              <router-link to="/course/help">
                                <img src="../assets/文档@2x.png" width="30px" alt /> 帮助文档
                              </router-link>
                            </p>
                          </div>
                        </el-col>
                      </el-row>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="tops">
                  <router-link to="/aboutour">关于我们</router-link>
                </div>
                <div class="tops">
                  <router-link to="/cooperate">合作</router-link>
                </div>
                <div class="tops login">
                  <button @click="logins">登录</button>
                </div>
              </div>
            </el-col>
            <div class="nav_right_phone" @click="open = !open">
              <!-- <transition name="el-zoom-in-center"> -->
                <span :class=" open ?  'iconfont icon-cha2': 'iconfont icon-sangang' "></span>
              <!-- </transition> -->
              &nbsp;&nbsp;首页
            </div>
          </el-row>
        </el-col>
      </el-row>
    </header>

    <!-- 移动端头部 -->
    <transition name="el-fade-in">
      <div class="caidan" v-show="open">
        <ul>
          <li>
            <router-link to="/">首页</router-link>
          </li>
          <li @click="openinfo = !openinfo">
            <a href="javascript:;">
              产品
              <i :class=" openinfo ? 'el-icon-arrow-down': 'el-icon-arrow-right' "></i>
            </a>
          </li>
          <transition name="el-fade-in">
            <div class="info" v-show="openinfo">
              <p>
                <router-link to="/retail">零售版</router-link>
              </p>
              <p>
                <router-link to="/warehouse">仓库版</router-link>
              </p>
              <p>
                <router-link to="/wholesaler">批发商版</router-link>
              </p>
              <p>
                <router-link to="/process">加工中心版</router-link>
              </p>
              <p>
                <router-link to="/businessProduct">商家后台</router-link>
              </p>
              <p>
                <router-link to="/publicNumberProduct">微信公众号</router-link>
              </p>
              <p>
                <router-link to="/smallProgramProduct">微信小程序</router-link>
              </p>
              <p>
                <router-link to="/money">收银机</router-link>
              </p>
              <p>
                <router-link to="/dispose">硬软件配置</router-link>
              </p>
            </div>
          </transition>
          <li @click="openinfo1 = !openinfo1">
            <a href="javascript:;">
              使用教程
              <i :class=" openinfo1 ? 'el-icon-arrow-down': 'el-icon-arrow-right' "></i>
            </a>
          </li>
          <transition name="el-fade-in">
            <div class="info" v-show="openinfo1">
              <p>
                <router-link to="/course/shop">特色功能使用视频</router-link>
              </p>
              <p>
                <router-link to="/course/help">帮助文档</router-link>
              </p>
            </div>
          </transition>
          <li>
            <router-link to="/aboutour">关于我们</router-link>
          </li>
          <li>
            <router-link to="/cooperate">合作</router-link>
          </li>
          <li>
            <a href="javascript:;" @click="logins">登录</a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
export default {
  data() {
    return {
      open: false,
      openinfo: false,
      openinfo1: false
    };
  },
  methods: {
    logins() {
      window.location.href = "http://cnc.jingliyun.com/admin/login.html";
    },
    hreftwo() {
      this.$router.push("/");
    }
  },
  mounted: function() {}
};
</script>


<style lang="less" scoped>
@import url("../assets/iconfont/font_home/iconfont.css");
.headers {
  padding-top: 70px;
  a {
    text-decoration: none;
    color: #258ffc;
  }
  header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 70px;
    background-color: #fff;
    line-height: 70px;
    z-index: 99;
    text-align: center;
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
    .nav_right {
      float: right;
    }
    .logo {
      padding: 5px;
      cursor: pointer;
      img {
        width: 80px;
        vertical-align: middle;
        margin-right: 5px;
      }
      span {
        font-size: 22px;
        //  color: #fff;
        vertical-align: middle;
      }
    }
    .login > button {
      padding: 5px 25px;
      border: 1px solid #323232;
      border-radius: 20px;
      background-color: transparent;
      outline: none;
      cursor: pointer;
      color: #323232;
      &:hover {
        background-color: #258ffc;
        color: #fff !important ;
        border: 1px solid #258ffc !important;
      }
    }
    .tops {
      height: 70px;
      float: left;
      margin: 0 20px;
      a {
        display: block;
        float: left;
        width: 100%;
        height: 100%;
        color: #323232;
        &:hover {
          border-bottom: 4px solid #258ffc;
          color: #258ffc;
          border-radius: 2px;
          font-weight: 800;
        }
      }
    }

    .nav_right {
      float: right;
      display: none;
    }
    .nav_right_phone {
      float: right;
      white-space: nowrap;
      vertical-align: middle;
      font-size: 17px;
      cursor: pointer;
      display: table-cell;
      padding: 0 10px;
      margin-right: 20px;
    }
    @media screen and (min-width: 830px) {
      .nav_right {
        display: block;
      }
      .nav_right_phone {
        display: none;
      }
    }
    @media screen and (max-width: 830px) {
      .nav_right {
        display: none;
      }
      .nav_right_phone {
        display: block;
      }
    }
  }
}
@media screen and (max-width: 830px) {
  .headers {
    padding-top: 50px;
    header {
      height: 50px;
      line-height: 50px;
      .logo {
        padding: 5px 10px;
        position: absolute;
        // padding: 5px;
        margin-top: -5px;
        cursor: pointer;
        img {
          width: 40px;
          vertical-align: middle;
          margin-right: 5px;
        }
        span {
          font-size: 16px;
          //  color: #fff;
          vertical-align: middle;
        }
      }
    }
  }
}
.caidan {
  position: fixed;
  top: 50px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 99;
  padding: 50px;
  ul {
    overflow: hidden;
    li {
      a {
        border-bottom: 1px solid #ccc;
        height: 47px;
        display: block;
        line-height: 47px;
        padding: 0 10px;
        font-size: 20px;
      }
      i {
        font-size: 20px;
        float: right;
        line-height: 47px;
      }
    }
    .info {
      padding: 10px;
      line-height: 40px;
      font-size: 20px;
      a {
        color: #323232;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.pulldown {
  // height: 360px;
  text-align: center;
  padding: 34px 0;
  .pulldown_b {
    float: left;
    p {
      margin: 0 0 33px 0;
      text-align: left;
      vertical-align: middle;
      font-size: 16px;
      color: #323232;
      img {
        width: 30px;
        vertical-align: middle;
        margin-right: 5px;
      }
      i {
        color: #268ffb;
        margin-right: 10px;
      }
      a {
        color: #666;
        &:hover {
          color: #268ffb;
          font-weight: 800;
        }
      }
    }
  }
}
</style>
